/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * Frontend JS.
 */
var $ = require("jquery");
var Flickity = require('flickity');


var galleryElems = document.querySelectorAll('.slider');
for ( var i=0, len = galleryElems.length; i < len; i++ ) {
    let galleryElem = galleryElems[i];

    if ($(window).width() < 768) {
        const flkty = new Flickity( galleryElem, {
            pageDots: true,
            prevNextButtons: true,
            groupCells: 1
        });
    } else if ($(window).width() < 992) {
        const flkty = new Flickity( galleryElem, {
            cellAlign: 'left',
            pageDots: true,
            prevNextButtons: true,
            groupCells: 2
        });
    } else if ($(window).width() < 1200) {
        const flkty = new Flickity( galleryElem, {
            cellAlign: 'left',
            pageDots: true,
            prevNextButtons: true,
            groupCells: 3
        });
    }
}